import { Injectable } from '@angular/core';
import { PharmacyAttention } from '../medical-record-page/pages/pharmacy/models/pharmacy-attention.model';
import { PharmacyIntervention } from '../medical-record-page/pages/pharmacy/models/pharmacy-intervation.model';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { QuestionnairesService } from './questionnaires.service';
import { IUser } from 'src/app/core/models/user.model';
import { AuthState } from 'src/app/core/store/auth/auth.state';
import { Store } from '@ngrx/store';
import { PatientService } from 'src/app/shared/services/patient/patient-info.service';
import { getAuthStateSelect } from 'src/app/core/store/auth/auth.selector';
import { QuestionariType } from '../model/questionnaire-response';
import { Errors, ErrorType } from 'src/app/shared/enums/error';

export type Pharmacy = PharmacyAttention | PharmacyIntervention;

@Injectable({
  providedIn: 'root'
})
export class PharmacyService {
  private patientSelectedId: string | null = null;
  private pharmacySubject = new BehaviorSubject<any>(null);

  subscription!: Subscription;
  userLogged: IUser | null = null;

  constructor(
    private questionnairesService: QuestionnairesService,
    private store: Store<AuthState>,
    private patientInfoService: PatientService,
  ) {
    this.pharmacySubject.next(null);

    this.subscription = (
      combineLatest([
        this.store.select(getAuthStateSelect),
        this.patientInfoService.getPatientId()
      ])
        .subscribe(([auth, patientId]) => {
          if (!auth.user || !patientId) return;

          this.userLogged = auth.user;
          this.patientSelectedId = patientId;
        }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get getPharmacy() {
    return this.pharmacySubject.asObservable();
  }

  async loadPharmacy(patientId: string, user: IUser): Promise<void> {

    this.pharmacySubject.next(null);
    await this.questionnairesService.getQuestionnaires(
      'pharmacy', patientId, user.practitionerId)
      .then(result => {
        if (result) {
          this.pharmacySubject.next({
            ...result,
            history: [...(result?.history ?? [])],
            myclinicHistory: [...(result?.myclinicHistory ?? [])],
            todayMulti: { ...result?.todayMulti }
          });
        }
      });
  }

  async savePharmacy({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.saveNewQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadPharmacy(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao salvar questionário de farmácia.',
        error
      );
    }
  }

  async updatePharmacy({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.updateQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadPharmacy(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao atualizar questionário de farmácia.',
        error
      );
    }
  }
}
